import React, { useEffect, useState } from "react";
import { UploadFileIcon } from "./Icon";

const AttachFileModal = ({ attachFileModal, setAttachFileModal }) => {
  // OVERLAY BEHIND ATTACH FILE MODEL
  const overLayHidden = () => {
    setAttachFileModal(!attachFileModal);
  };

  // OVERFLOW HIDDEN WHEN ATTACH FILE MODAL OPEN
  useEffect(() => {
    if (attachFileModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [attachFileModal]);

  // ATTACH FILE VALUE
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [setDragging] = useState(false);
  // Function to handle file selection
  const handleFileSelect = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setSelectedFiles(selectedFiles);
  };

  // Function to handle file drop
  const handleFileDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setSelectedFiles(droppedFiles);
    setDragging(false);
  };

  // Prevent the default behavior when files are dropped
  const handleDragOver = (e) => {
    e.preventDefault();
  };
  return (
    <>
      <div className=" ">
        <div className="bg-white px-[20px] md:px-[63px] py-[30px] w-[320px] xs:w-[375px] xm:max-w-[500px] xm:w-full rounded-[36px] border-[3.043px] border-solid border-[rgba(111,_106,_248,_0.10)] shadow-upload_file_shadow relative z-[99999999]">
          <h3 className="text-[24px] font-semibold text-black text-center">
            Upload File
          </h3>
          <label
            onDragOver={handleDragOver}
            onDrop={handleFileDrop}
            className="cursor-pointer"
            htmlFor="my-file">
            <div className="rounded-[10px] border-[1.092px] border-dashed border-primary py-[21px] px-[70px] sm:px-[92px] mt-4">
              <div className="w-full flex justify-start flex-col items-center">
                <span>
                  <UploadFileIcon />
                </span>
                <input
                  type="file"
                  id="my-file"
                  onChange={handleFileSelect}
                  hidden
                  multiple
                />
                <p className="text-[14px] font-normal text-black opacity-70 pt-1 text-center">
                  Drop your files here!
                </p>
              </div>
              <div className=" pt-7">
                {selectedFiles.map((file, index) => (
                  <p className="text-[14px] font-medium text-black" key={index}>
                    {file.name}
                  </p>
                ))}
              </div>
            </div>
          </label>
          <input
            className="text-[10px] 3xl:text-[13px] font-normal outline-primary  text-black placeholder:text-black/40 3xl:placeholder:text-black/60  p-3 rounded-lg border border-solid border-[rgba(146,_146,_146,_0.30)] w-full mt-3"
            type="text"
            placeholder="Add Notes"
          />
          <div className="flex justify-center gap-3 pt-8">
            <button
              onClick={() => setAttachFileModal(false)}
              className="text-[24px] font-semibold text-black rounded-[53px] opacity-[0.24] border border-solid border-transparent bg-gray py-[6px] px-6 hover:text-primary hover:border-primary hover:bg-white hover:opacity-100 duration-200">
              Skip
            </button>
            <button
              onClick={() => setAttachFileModal(false)}
              className="text-[24px] font-semibold text-white rounded-[53px] bg-primary py-[6px] px-6 border border-solid border-transparent  hover:bg-white hover:text-primary hover:border-primary  duration-200 ">
              Next
            </button>
          </div>
        </div>
      </div>
      <div
        onClick={overLayHidden}
        className={` fixed inset-0 min-h-full z-[999999]  bg-black opacity-10 ${
          attachFileModal ? "w-[100%] " : "hidden"
        }`}></div>
    </>
  );
};

export default AttachFileModal;
